import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LandingBaseModule } from './base/landing-base.module';
import { landingRoutes } from './landing-routing.config';
import {
  StartPageBaseNewComponent
} from '../libs/profilum-components/src/lib/components/start-page-base-new/start-page-base-new.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(landingRoutes),
    SharedModule,
    LandingBaseModule,
    StartPageBaseNewComponent,
  ],
})
export class LandingModule {}
